import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf'
import 'jspdf-autotable'
import { LoaderService } from 'src/app/services/loader.service';

@Injectable({
    providedIn: 'root'
})
export class AutoTableUtils {

    constructor(private loaderScreenService: LoaderService) {
    }

    public descargar() {
        const doc = new jsPDF()
        doc.autoTable({ html: '#my-table' })
        doc.save('table.pdf')
    }

}
